import styled from 'styled-components';
import { Column } from 'components/shared/Layout';
import { MEDIA_QUERIES } from 'constants/breakpoints';

const ResponsiveColumn = styled(Column)`
  grid-column: span ${(props) => props.smallScreens} !important;

  @media ${MEDIA_QUERIES.isDesktop} {
    grid-column: span ${(props) => props.bigScreens} !important;
  }
`;

export default ResponsiveColumn;
